import type {
  MutationUpdateDefaultSsoStatusArgs,
  Action,
  Sso,
  DefaultSsoType,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getSsosKey } from '../../utils/keys/authToken.keys.js'

export const useUpdateDefaultSsoStatus = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    Error,
    MutationUpdateDefaultSsoStatusArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const ssosKey = getSsosKey()

  return useMutation<Action, Error, MutationUpdateDefaultSsoStatusArgs>(
    input => client.auth.updateDefaultSsoStatus(input),
    {
      onMutate: variables => {
        queryClient.cancelQueries(ssosKey)
        queryClient.setQueriesData<Sso[]>(ssosKey, old =>
          old.map(sso => ({
            ...sso,
            status:
              (sso.type as unknown as DefaultSsoType) === variables.sso
                ? variables.status
                : sso.status,
          })),
        )
      },
      onSettled: () => {
        queryClient.invalidateQueries(ssosKey)
      },
      ...useMutationOptions,
    },
  )
}
